import {
  deliveryMenu,
  expressBasicMenu,
  sameNextDayMenu,
  massiveMenu,
  paymentsMenu,
  receiptsMenu,
  favoriteAddressMenu,
  dashboardMenu,
  historicalMenu,
} from 'src/app/components/shared/sharedConstants/menu.constants';
import { countries, sharedConstants, ui, freshChat, kushki } from './constants';

const constants = {
  ...countries,
  ...ui,
  freshChat,
  kushki,
  guardClause: null,
  shared: {
    ...sharedConstants,
    enableAllPermissions: false,
  },
  listofmenu: [
    dashboardMenu,
    historicalMenu,
    deliveryMenu,
    expressBasicMenu,
    sameNextDayMenu,
    massiveMenu,
    favoriteAddressMenu,
    paymentsMenu,
    receiptsMenu,
  ],
};

export const environment = {
  environmentName: 'dev',
  production: false,
  hostname: 'https://mu-system-proxy.dev.murbanos.co',
  hostnameApi: 'https://dev.api.mensajerosurbanos.com',
  hostnameMassive: 'https://mu-platform.dev.murbanos.co',
  hostnameSndBFF: 'https://mu-bff-snd.dev.murbanos.co',
  hostMobile: 'https://bff-mobile.dev.murbanos.co',
  hostBffDashboard: 'https://bff-dashboard.dev.murbanos.co',
  hostTraceability: '/snd/traceability/package/',
  hostFailed: '/snd/traceability/failed-attends/',
  hostTrackStatusList: '/snd/traceability/tracking/package/',
  hostMassivePort: '',
  hostMassivePortUpload: '',
  hostPort: '',
  nonTrackingDomain: 'localhost',
  clientId: '5af7187e987ab_murbanos',
  clientSecret: '3753a0f5196e483cf57673dc128662aa03f6fa5b',
  hostfintech: 'https://bff-fintech.dev.murbanos.co',
  hostInternal: 'https://bff-company.dev.murbanos.co',
  hostBffInternal: 'https://bff-internal-services.dev.murbanos.co',
  hostTimelineApi: 'https://bff-plataforma-unificada.dev.murbanos.co',
  chat: {
    widgetBaseUrl: 'https://pqrs.mensajerosurbanos.com/chat-widget/',
    slug: 'prueba-widget',
    width: 376,
    height: 540,
  },
  chatExperiment: {
    name: 'mu_freschat_flow',
    capitalCityIds: { CO: 1, MX: 50 },
    timeoutMs: 5000,
  },
  helpLink: 'https://pqrs.mensajerosurbanos.com/centro-de-ayuda',
  testLoginEmail: '',
  testLoginPassword: '',
  webSocketUrl: 'wss://e1wqarl6x3.execute-api.us-west-2.amazonaws.com/dev',
  webSocketFrontUrl: 'wss://dev.realtime.mensajerosurbanos.com/socket_front?access_token=',
  webSocketTaskPerCompanyUrl:
    'wss://dev.realtime.mensajerosurbanos.com/socket_tasks_per_company?access_token=f13732653e22cb363ee945b0aa5b7009d6b47cfd',
  webSocketAdminCourierUrl:
    'wss://dev.realtime.mensajerosurbanos.com/socket_admin_all_couriers?token=1a425d05337e9513683eec390f8e2ceb31e33da198b3a573721356b52271cb8616567c5ae6faeed99ad8069f7d492939',
  webSocketClientVersion: 1,
  cancellationLinkCO: 'https://web.mensajerosurbanos.com/terminos-y-condiciones',
  cancellationLinkMX: 'https://web.mensajerosurbanos.com/mx/terminos-y-condiciones',
  principalMULink: 'https://www.mensajerosurbanos.com/',
  kushkiInTest: true,
  googleAnalyticsId: 'G-HNR7522M5Y',
  timeVerifyVersion: 180000,
  timeReloadPointsUser: 1200000,
  publicDeliveryTrackShortLink: 'https://tinyurl.com/bdejuyus/',
  FacebookPixelId: '464174501873804',
  featureFlags: {
    dashboardMpay: true,
  },
  ...constants,
};
